/* eslint-disable react/prop-types */

import React from 'react';
import { Label, LabelInner, LabelText, ComponentWrap } from './radioButton.style';

function CustomLabel({ label, labelEnd, component, componentEnd, isFlex }) {
  return (
    <Label isFlex={isFlex}>
      <LabelInner>
        <LabelText>{label}</LabelText>
        <ComponentWrap>{component}</ComponentWrap>
      </LabelInner>
      <LabelInner>
        <LabelText>{labelEnd}</LabelText>
        <ComponentWrap>{componentEnd}</ComponentWrap>
      </LabelInner>
    </Label>
  );
}

export default CustomLabel;
